import { dayjsUTC } from "@/helpers/dateHelper"
import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { WarrantsDcaTicket } from "@/models/admin/warrantsDcaTicket/warrantsDcaTicket"
import { IWarrantsDcaTicket } from "@/models/admin/warrantsDcaTicket/warrantsDcaTicket.types"

/**
 * A single `warrants_dca_tickets` row as returned by Hasura. Mirrors the
 * generated `Financials_Warrants_Dca_Tickets` row; kept as a narrow type so the
 * parser only depends on the columns it actually reads.
 */
export type WarrantsDcaTicketRaw = {
  id: number
  account_number: string
  dca_type: string
  status: string
  type: string
  ticket_definition?: string | null
  ticket_id?: string | null
  ticket_step?: string | null
  created_at: string
  deleted_at?: string | null
}

export const WarrantsDcaTicketParser: IParser<
  IWarrantsDcaTicket,
  WarrantsDcaTicketRaw
> = {
  toDomain(data) {
    try {
      // Hasura `timestamp` columns are naive UTC, so parse them as UTC and
      // convert to local time for display.
      return new WarrantsDcaTicket(
        data.id,
        data.account_number,
        data.dca_type,
        data.status,
        data.type,
        data.ticket_definition ?? null,
        data.ticket_id ?? null,
        data.ticket_step ?? null,
        dayjsUTC(data.created_at),
        data.deleted_at ? dayjsUTC(data.deleted_at) : null,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
